import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { strictParse as de } from "../../date-picker/src/utils.js";
import { timePickerInjectionKey as st } from "./interface.js";
import dt from "./Panel.js";
import ct from "./styles/index.cssr.js";
import { isTimeInStep as B, findSimilarTime as mt } from "./utils.js";
import { warnOnce as ft } from "../../_utils/naive/warn.js";
import ht from "../../_mixins/use-config.js";
import vt from "../../_mixins/use-locale.js";
import gt from "../../_mixins/use-form-item.js";
import ve from "../../_mixins/use-theme.js";
import pt from "../styles/light.js";
import Tt from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-keyboard.js";
import { formatInTimeZone as Ft } from "../../../../../../date-fns-tz@3.2.0_date-fns@3.6.0/node_modules/date-fns-tz/dist/esm/formatInTimeZone/index.js";
import Ct from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { useThemeClass as ce } from "../../_mixins/use-css-vars-class.js";
import Vt from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import bt from "../../input/src/Input.js";
import It from "../../_internal/icon/src/Icon.js";
import St from "../../_internal/icons/Time.js";
import wt from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/clickoutside.js";
import { call as c } from "../../_utils/vue/call.js";
import { markEventEffectPerformed as me } from "../../_utils/event/index.js";
import { happensIn as Rt } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/happens-in.js";
import { setHours as C } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/setHours.js";
import { startOfHour as yt } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfHour.js";
import { setMinutes as $ } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/setMinutes.js";
import { startOfMinute as kt } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfMinute.js";
import { setSeconds as Z } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/setSeconds.js";
import { getPreciseEventTarget as Dt } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { getMinutes as fe } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getMinutes.js";
import { getSeconds as he } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getSeconds.js";
import { getMilliseconds as Pt } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getMilliseconds.js";
import { defineComponent as zt, watchEffect as At, computed as l, watch as L, nextTick as q, provide as Ht, h as g, withDirectives as Mt } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as V, toRef as xt } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { formatDate as Bt } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/format.js";
import { getHours as z } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getHours.js";
import { useAdjustedTo as G } from "../../_utils/composable/use-adjusted-to.js";
import Nt from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Binder.js";
import Ut from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Target.js";
import Ot from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Follower.js";
import { Transition as _t } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { getTime as s } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getTime.js";
import { startOfSecond as Et } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfSecond.js";
import { isValid as Kt } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isValid.js";
import { set as jt } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/set.js";
function W(n, T) {
  return n === void 0 ? !0 : Array.isArray(n) ? n.every((d) => d >= 0 && d <= T) : n >= 0 && n <= T;
}
const $t = Object.assign(Object.assign({}, ve.props), {
  to: G.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  actions: Array,
  defaultValue: {
    type: Number,
    default: null
  },
  defaultFormattedValue: String,
  placeholder: String,
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: Number,
  format: {
    type: String,
    default: "HH:mm:ss"
  },
  valueFormat: String,
  formattedValue: String,
  isHourDisabled: Function,
  size: String,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  inputReadonly: Boolean,
  clearable: Boolean,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onBlur: [Function, Array],
  onConfirm: [Function, Array],
  onClear: Function,
  onFocus: [Function, Array],
  // https://www.iana.org/time-zones
  timeZone: String,
  showIcon: {
    type: Boolean,
    default: !0
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  hours: {
    type: [Number, Array],
    validator: (n) => W(n, 23)
  },
  minutes: {
    type: [Number, Array],
    validator: (n) => W(n, 59)
  },
  seconds: {
    type: [Number, Array],
    validator: (n) => W(n, 59)
  },
  use12Hours: Boolean,
  // private
  stateful: {
    type: Boolean,
    default: !0
  },
  // deprecated
  onChange: [Function, Array]
}), Un = zt({
  name: "TimePicker",
  props: $t,
  setup(n) {
    process.env.NODE_ENV !== "production" && At(() => {
      n.onChange !== void 0 && ft("time-picker", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedBorderedRef: T,
      mergedClsPrefixRef: d,
      namespaceRef: k,
      inlineThemeDisabled: A
    } = ht(n), {
      localeRef: D,
      dateLocaleRef: ge
    } = vt("TimePicker"), H = gt(n), {
      mergedSizeRef: pe,
      mergedDisabledRef: M,
      mergedStatusRef: Te
    } = H, x = ve("TimePicker", "-time-picker", ct, pt, n, d), Fe = Tt(), b = V(null), I = V(null), F = l(() => ({
      locale: ge.value.locale
    }));
    function J(e) {
      return e === null ? null : de(e, n.valueFormat || n.format, /* @__PURE__ */ new Date(), F.value).getTime();
    }
    const {
      defaultValue: Ce,
      defaultFormattedValue: Q
    } = n, N = V(Q !== void 0 ? J(Q) : Ce), r = l(() => {
      const {
        formattedValue: e
      } = n;
      if (e !== void 0)
        return J(e);
      const {
        value: t
      } = n;
      return t !== void 0 ? t : N.value;
    }), S = l(() => {
      const {
        timeZone: e
      } = n;
      return e ? (t, i, o) => Ft(t, e, i, o) : (t, i, o) => Bt(t, i, o);
    }), P = V("");
    L(() => n.timeZone, () => {
      const e = r.value;
      P.value = e === null ? "" : S.value(e, n.format, F.value);
    }, {
      immediate: !0
    });
    const X = V(!1), Ve = xt(n, "show"), m = Ct(Ve, X), U = V(r.value), O = V(!1), be = l(() => D.value.clear), Ie = l(() => D.value.now), Se = l(() => n.placeholder !== void 0 ? n.placeholder : D.value.placeholder), we = l(() => D.value.negativeText), Re = l(() => D.value.positiveText), ye = l(() => /H|h|K|k/.test(n.format)), ke = l(() => n.format.includes("m")), De = l(() => n.format.includes("s")), w = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : Number(S.value(e, "HH", F.value));
    }), _ = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : Number(S.value(e, "mm", F.value));
    }), Y = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : Number(S.value(e, "ss", F.value));
    }), ee = l(() => {
      const {
        isHourDisabled: e
      } = n;
      return w.value === null ? !1 : B(w.value, "hours", n.hours) ? e ? e(w.value) : !1 : !0;
    }), te = l(() => {
      const {
        value: e
      } = _, {
        value: t
      } = w;
      if (e === null || t === null)
        return !1;
      if (!B(e, "minutes", n.minutes))
        return !0;
      const {
        isMinuteDisabled: i
      } = n;
      return i ? i(e, t) : !1;
    }), ne = l(() => {
      const {
        value: e
      } = _, {
        value: t
      } = w, {
        value: i
      } = Y;
      if (i === null || e === null || t === null)
        return !1;
      if (!B(i, "seconds", n.seconds))
        return !0;
      const {
        isSecondDisabled: o
      } = n;
      return o ? o(i, e, t) : !1;
    }), ie = l(() => ee.value || te.value || ne.value), Pe = l(() => n.format.length + 4), ze = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : z(e) < 12 ? "am" : "pm";
    });
    function Ae(e, t) {
      const {
        onUpdateFormattedValue: i,
        "onUpdate:formattedValue": o
      } = n;
      i && c(i, e, t), o && c(o, e, t);
    }
    function oe(e) {
      return e === null ? null : S.value(e, n.valueFormat || n.format);
    }
    function a(e) {
      const {
        onUpdateValue: t,
        "onUpdate:value": i,
        onChange: o
      } = n, {
        nTriggerFormChange: h,
        nTriggerFormInput: v
      } = H, u = oe(e);
      t && c(t, e, u), i && c(i, e, u), o && c(o, e, u), Ae(u, e), N.value = e, h(), v();
    }
    function He(e) {
      const {
        onFocus: t
      } = n, {
        nTriggerFormFocus: i
      } = H;
      t && c(t, e), i();
    }
    function E(e) {
      const {
        onBlur: t
      } = n, {
        nTriggerFormBlur: i
      } = H;
      t && c(t, e), i();
    }
    function Me() {
      const {
        onConfirm: e
      } = n;
      e && c(e, r.value, oe(r.value));
    }
    function xe(e) {
      var t;
      e.stopPropagation(), a(null), p(null), (t = n.onClear) === null || t === void 0 || t.call(n);
    }
    function Be() {
      f({
        returnFocus: !0
      });
    }
    function Ne() {
      a(null), p(null), f({
        returnFocus: !0
      });
    }
    function Ue(e) {
      e.key === "Escape" && m.value && me(e);
    }
    function Oe(e) {
      var t;
      switch (e.key) {
        case "Escape":
          m.value && (me(e), f({
            returnFocus: !0
          }));
          break;
        case "Tab":
          Fe.shift && e.target === ((t = I.value) === null || t === void 0 ? void 0 : t.$el) && (e.preventDefault(), f({
            returnFocus: !0
          }));
          break;
      }
    }
    function _e() {
      O.value = !0, q(() => {
        O.value = !1;
      });
    }
    function Ee(e) {
      M.value || Rt(e, "clear") || m.value || le();
    }
    function Ke(e) {
      typeof e != "string" && (r.value === null ? a(s(C(yt(/* @__PURE__ */ new Date()), e))) : a(s(C(r.value, e))));
    }
    function je(e) {
      typeof e != "string" && (r.value === null ? a(s($(kt(/* @__PURE__ */ new Date()), e))) : a(s($(r.value, e))));
    }
    function $e(e) {
      typeof e != "string" && (r.value === null ? a(s(Z(Et(/* @__PURE__ */ new Date()), e))) : a(s(Z(r.value, e))));
    }
    function Ze(e) {
      const {
        value: t
      } = r;
      if (t === null) {
        const i = /* @__PURE__ */ new Date(), o = z(i);
        e === "pm" && o < 12 ? a(s(C(i, o + 12))) : e === "am" && o >= 12 && a(s(C(i, o - 12))), a(s(i));
      } else {
        const i = z(t);
        e === "pm" && i < 12 ? a(s(C(t, i + 12))) : e === "am" && i >= 12 && a(s(C(t, i - 12)));
      }
    }
    function p(e) {
      e === void 0 && (e = r.value), e === null ? P.value = "" : P.value = S.value(e, n.format, F.value);
    }
    function Le(e) {
      j(e) || He(e);
    }
    function qe(e) {
      var t;
      if (!j(e))
        if (m.value) {
          const i = (t = I.value) === null || t === void 0 ? void 0 : t.$el;
          i != null && i.contains(e.relatedTarget) || (p(), E(e), f({
            returnFocus: !1
          }));
        } else
          p(), E(e);
    }
    function We() {
      M.value || m.value || le();
    }
    function Ge() {
      M.value || (p(), f({
        returnFocus: !1
      }));
    }
    function re() {
      if (!I.value)
        return;
      const {
        hourScrollRef: e,
        minuteScrollRef: t,
        secondScrollRef: i,
        amPmScrollRef: o
      } = I.value;
      [e, t, i, o].forEach((h) => {
        var v;
        if (!h)
          return;
        const u = (v = h.contentRef) === null || v === void 0 ? void 0 : v.querySelector("[data-active]");
        u && h.scrollTo({
          top: u.offsetTop
        });
      });
    }
    function K(e) {
      X.value = e;
      const {
        onUpdateShow: t,
        "onUpdate:show": i
      } = n;
      t && c(t, e), i && c(i, e);
    }
    function j(e) {
      var t, i, o;
      return !!(!((i = (t = b.value) === null || t === void 0 ? void 0 : t.wrapperElRef) === null || i === void 0) && i.contains(e.relatedTarget) || !((o = I.value) === null || o === void 0) && o.$el.contains(e.relatedTarget));
    }
    function le() {
      U.value = r.value, K(!0), q(re);
    }
    function Je(e) {
      var t, i;
      m.value && !(!((i = (t = b.value) === null || t === void 0 ? void 0 : t.wrapperElRef) === null || i === void 0) && i.contains(Dt(e))) && f({
        returnFocus: !1
      });
    }
    function f({
      returnFocus: e
    }) {
      var t;
      m.value && (K(!1), e && ((t = b.value) === null || t === void 0 || t.focus()));
    }
    function Qe(e) {
      if (e === "") {
        a(null);
        return;
      }
      const t = de(e, n.format, /* @__PURE__ */ new Date(), F.value);
      if (P.value = e, Kt(t)) {
        const {
          value: i
        } = r;
        if (i !== null) {
          const o = jt(i, {
            hours: z(t),
            minutes: fe(t),
            seconds: he(t),
            milliseconds: Pt(t)
          });
          a(s(o));
        } else
          a(s(t));
      }
    }
    function Xe() {
      a(U.value), K(!1);
    }
    function Ye() {
      const e = /* @__PURE__ */ new Date(), t = {
        hours: z,
        minutes: fe,
        seconds: he
      }, [i, o, h] = ["hours", "minutes", "seconds"].map((u) => !n[u] || B(t[u](e), u, n[u]) ? t[u](e) : mt(t[u](e), u, n[u])), v = Z($(C(r.value ? r.value : s(e), i), o), h);
      a(s(v));
    }
    function et() {
      p(), Me(), f({
        returnFocus: !0
      });
    }
    function tt(e) {
      j(e) || (p(), E(e), f({
        returnFocus: !1
      }));
    }
    L(r, (e) => {
      p(e), _e(), q(re);
    }), L(m, () => {
      ie.value && a(U.value);
    }), Ht(st, {
      mergedThemeRef: x,
      mergedClsPrefixRef: d
    });
    const ae = {
      focus: () => {
        var e;
        (e = b.value) === null || e === void 0 || e.focus();
      },
      blur: () => {
        var e;
        (e = b.value) === null || e === void 0 || e.blur();
      }
    }, ue = l(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          iconColor: t,
          iconColorDisabled: i
        }
      } = x.value;
      return {
        "--n-icon-color-override": t,
        "--n-icon-color-disabled-override": i,
        "--n-bezier": e
      };
    }), R = A ? ce("time-picker-trigger", void 0, ue, n) : void 0, se = l(() => {
      const {
        self: {
          panelColor: e,
          itemTextColor: t,
          itemTextColorActive: i,
          itemColorHover: o,
          panelDividerColor: h,
          panelBoxShadow: v,
          itemOpacityDisabled: u,
          borderRadius: nt,
          itemFontSize: it,
          itemWidth: ot,
          itemHeight: rt,
          panelActionPadding: lt,
          itemBorderRadius: at
        },
        common: {
          cubicBezierEaseInOut: ut
        }
      } = x.value;
      return {
        "--n-bezier": ut,
        "--n-border-radius": nt,
        "--n-item-color-hover": o,
        "--n-item-font-size": it,
        "--n-item-height": rt,
        "--n-item-opacity-disabled": u,
        "--n-item-text-color": t,
        "--n-item-text-color-active": i,
        "--n-item-width": ot,
        "--n-panel-action-padding": lt,
        "--n-panel-box-shadow": v,
        "--n-panel-color": e,
        "--n-panel-divider-color": h,
        "--n-item-border-radius": at
      };
    }), y = A ? ce("time-picker", void 0, se, n) : void 0;
    return {
      focus: ae.focus,
      blur: ae.blur,
      mergedStatus: Te,
      mergedBordered: T,
      mergedClsPrefix: d,
      namespace: k,
      uncontrolledValue: N,
      mergedValue: r,
      isMounted: Vt(),
      inputInstRef: b,
      panelInstRef: I,
      adjustedTo: G(n),
      mergedShow: m,
      localizedClear: be,
      localizedNow: Ie,
      localizedPlaceholder: Se,
      localizedNegativeText: we,
      localizedPositiveText: Re,
      hourInFormat: ye,
      minuteInFormat: ke,
      secondInFormat: De,
      mergedAttrSize: Pe,
      displayTimeString: P,
      mergedSize: pe,
      mergedDisabled: M,
      isValueInvalid: ie,
      isHourInvalid: ee,
      isMinuteInvalid: te,
      isSecondInvalid: ne,
      transitionDisabled: O,
      hourValue: w,
      minuteValue: _,
      secondValue: Y,
      amPmValue: ze,
      handleInputKeydown: Ue,
      handleTimeInputFocus: Le,
      handleTimeInputBlur: qe,
      handleNowClick: Ye,
      handleConfirmClick: et,
      handleTimeInputUpdateValue: Qe,
      handleMenuFocusOut: tt,
      handleCancelClick: Xe,
      handleClickOutside: Je,
      handleTimeInputActivate: We,
      handleTimeInputDeactivate: Ge,
      handleHourClick: Ke,
      handleMinuteClick: je,
      handleSecondClick: $e,
      handleAmPmClick: Ze,
      handleTimeInputClear: xe,
      handleFocusDetectorFocus: Be,
      handleMenuKeydown: Oe,
      handleTriggerClick: Ee,
      mergedTheme: x,
      triggerCssVars: A ? void 0 : ue,
      triggerThemeClass: R == null ? void 0 : R.themeClass,
      triggerOnRender: R == null ? void 0 : R.onRender,
      cssVars: A ? void 0 : se,
      themeClass: y == null ? void 0 : y.themeClass,
      onRender: y == null ? void 0 : y.onRender,
      clearSelectedValue: Ne
    };
  },
  render() {
    const {
      mergedClsPrefix: n,
      $slots: T,
      triggerOnRender: d
    } = this;
    return d == null || d(), g("div", {
      class: [`${n}-time-picker`, this.triggerThemeClass],
      style: this.triggerCssVars
    }, g(Nt, null, {
      default: () => [g(Ut, null, {
        default: () => g(bt, {
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: this.displayTimeString,
          bordered: this.mergedBordered,
          passivelyActivated: !0,
          attrSize: this.mergedAttrSize,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          stateful: this.stateful,
          size: this.mergedSize,
          placeholder: this.localizedPlaceholder,
          clearable: this.clearable,
          disabled: this.mergedDisabled,
          textDecoration: this.isValueInvalid ? "line-through" : void 0,
          onFocus: this.handleTimeInputFocus,
          onBlur: this.handleTimeInputBlur,
          onActivate: this.handleTimeInputActivate,
          onDeactivate: this.handleTimeInputDeactivate,
          onUpdateValue: this.handleTimeInputUpdateValue,
          onClear: this.handleTimeInputClear,
          internalDeactivateOnEnter: !0,
          internalForceFocus: this.mergedShow,
          readonly: this.inputReadonly || this.mergedDisabled,
          onClick: this.handleTriggerClick,
          onKeydown: this.handleInputKeydown
        }, this.showIcon ? {
          [this.clearable ? "clear-icon-placeholder" : "suffix"]: () => g(It, {
            clsPrefix: n,
            class: `${n}-time-picker-icon`
          }, {
            default: () => T.icon ? T.icon() : g(St, null)
          })
        } : null)
      }), g(Ot, {
        teleportDisabled: this.adjustedTo === G.tdkey,
        show: this.mergedShow,
        to: this.adjustedTo,
        containerClass: this.namespace,
        placement: this.placement
      }, {
        default: () => g(_t, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => {
            var k;
            return this.mergedShow ? ((k = this.onRender) === null || k === void 0 || k.call(this), Mt(g(dt, {
              ref: "panelInstRef",
              actions: this.actions,
              class: this.themeClass,
              style: this.cssVars,
              seconds: this.seconds,
              minutes: this.minutes,
              hours: this.hours,
              transitionDisabled: this.transitionDisabled,
              hourValue: this.hourValue,
              showHour: this.hourInFormat,
              isHourInvalid: this.isHourInvalid,
              isHourDisabled: this.isHourDisabled,
              minuteValue: this.minuteValue,
              showMinute: this.minuteInFormat,
              isMinuteInvalid: this.isMinuteInvalid,
              isMinuteDisabled: this.isMinuteDisabled,
              secondValue: this.secondValue,
              amPmValue: this.amPmValue,
              showSecond: this.secondInFormat,
              isSecondInvalid: this.isSecondInvalid,
              isSecondDisabled: this.isSecondDisabled,
              isValueInvalid: this.isValueInvalid,
              clearText: this.localizedClear,
              nowText: this.localizedNow,
              confirmText: this.localizedPositiveText,
              use12Hours: this.use12Hours,
              onFocusout: this.handleMenuFocusOut,
              onKeydown: this.handleMenuKeydown,
              onHourClick: this.handleHourClick,
              onMinuteClick: this.handleMinuteClick,
              onSecondClick: this.handleSecondClick,
              onAmPmClick: this.handleAmPmClick,
              onNowClick: this.handleNowClick,
              onConfirmClick: this.handleConfirmClick,
              onClearClick: this.clearSelectedValue,
              onFocusDetectorFocus: this.handleFocusDetectorFocus
            }), [[wt, this.handleClickOutside, void 0, {
              capture: !0
            }]])) : null;
          }
        })
      })]
    }));
  }
});
export {
  Un as default,
  $t as timePickerProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/time-picker/src/TimePicker.js
// module id = 934
// module chunks = 41